import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const getActivityList = (query) => AxiosClient.get('/activity', query);
const getAllAcivity = (query) => AxiosClient.get('/activities', query);

export {
    getActivityList,
    getAllAcivity
}